function isValidCoordinates(coordinates) {
    if (!coordinates.match(/^[-]?\d+[.]?\d*, [-]?\d+[.]?\d*$/)) {
        return false;
    }
    const [latitude, longitude]=coordinates.split(",");
    return (latitude>-90 && latitude<90 && longitude>-180 && longitude<180);
}

export default isValidCoordinates;